/* 非父子组件通信 */
import Vue from 'vue'
const eventBus = new Vue()
export {eventBus}



// WEBPACK FOOTER //
// ./src/eventbus.js